import { Reveal } from "../components/Reveal";
import { SectionLabel } from "../components/SectionLabel";
import SoCalMap from "../components/SoCalMap";
import { SITE } from "../config/site";

const STATS = [
  { id: "markets", value: "3", label: "Core counties — Orange, Los Angeles + surrounding" },
  { id: "team", value: "1", label: "Team from idea through installation" },
  { id: "possibilities", value: "∞", label: "Ways to make it unforgettable" },
];

export default function SoCal() {
  return (
    <section id="studio" data-testid="socal-section" className="scroll-mt-20 bg-panel">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-36">
        <Reveal>
          <SectionLabel index="CH.08">The Studio</SectionLabel>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <Reveal>
              <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.12] tracking-tight text-paper sm:text-5xl sm:leading-[1.08]">
                Close to the culture.
                <br />
                Built for the <span className="text-uv-glow">industry.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 text-base leading-relaxed text-fog sm:text-lg">
                Based in Hawaiian Gardens — right where Orange County meets Los Angeles County —
                Triple O supports California's cannabis brands, retailers, events and conventions
                without the out-of-state guessing game.
              </p>
            </Reveal>
            <div className="mt-12 space-y-0">
              {STATS.map((s, i) => (
                <Reveal key={s.id} delay={0.1 * i}>
                  <div
                    data-testid={`socal-stat-${s.id}`}
                    className="flex items-baseline gap-6 border-t border-white/10 py-6 last:border-b"
                  >
                    <span className="w-20 shrink-0 font-display text-5xl font-extrabold leading-none text-acid lg:text-6xl">
                      {s.value}
                    </span>
                    <span className="font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-paper/60">
                      {s.label}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.3}>
              <p
                data-testid="socal-travel-note"
                className="mt-8 border-l-2 border-acid pl-4 font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-paper/70"
              >
                {SITE.travel}.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="lg:col-span-7" y={40}>
            <SoCalMap />
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-paper/40">
              Southern California event venues
            </p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-paper/30">
              Illustrative map
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
